import MutationObserver from "../polyfills/web.naive-mutationobserver.js";

const errorInstance = {};// fake instance used when the component constructor throw an error
const registry = new Map();
const collections = new Map();
const upgradedElements = new WeakMap();
const upgradeConflicts = new WeakMap();

// FIXME support lifecycle callbacks https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#Using_the_lifecycle_callbacks

// https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry
export default {
  define(name, constructor, options){
    if(registry.has(name) || [...registry.values()].includes(constructor)){
      throw Object.assign(new Error("The registry already contains an entry with the same name or the same constructor"), {name: "NotSupportedError"});
    }

    if(!name.startsWith("js-")){
      throw new SyntaxError("The provided name is not a valid component name");
    }

    if(typeof constructor !== "function"){
      throw new TypeError("The referenced constructor is not a constructor.")
    }

    registry.set(name, constructor);
    collections.set(name, document.getElementsByClassName(name));
  },

  get(name){
    return registry.get(name);
  },

  whenDefined(name) {
    console.error("Not implemented");
  }
};

new MutationObserver(() => {
  for(const [name, collection] of collections){
    for(const element of collection){
      const constructor = registry.get(name);
      const upgradedElementInstance = upgradedElements.get(element);

      if(upgradedElementInstance === undefined){
        element.setAttribute("component:" + name, "");
        let instance;
        try{
          instance = new constructor({el: element});
        }catch(error){
          console.error(error);
          instance = errorInstance;// replace the can't-be-created instance with a placeholder
        }
        upgradedElements.set(element, instance);
        continue;
      }

      if(
        // The construction of that element thrown an error
        upgradedElementInstance === errorInstance
        // Same constructor (no conflict), already instantiated, nothing to do
        || upgradedElementInstance instanceof constructor
      ){
        continue;
      }

      let conflict = upgradeConflicts.get(element);
      // has conflict with this constructor, but already known
      if(conflict && conflict.has(constructor)){
        continue;
      }

      if(conflict === undefined){
        conflict = new Set();
      }

      upgradeConflicts.set(element, conflict.add(constructor));
      console.error(new TypeError(`Components can't reuse same element`))
    }
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
});
